/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 */

export type InvitationType =
  (typeof InvitationType)[keyof typeof InvitationType];

export const InvitationType = {
  application: 'application',
  tenant: 'tenant',
} as const;
